import React, { useEffect, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CustomTable from "../../../components/table/Table";
import logo from "../../../assets/images/logo.jpeg";
import { Add } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from "../../../redux/Slice/Product";

const columns = [
  { id: 'id', label: 'S.No', minWidth: 150, align: 'start' },
  // { id: 'image', label: 'Product Image', minWidth: 150, align: 'start' },
  { id: 'product_name', label: 'Product Name', minWidth: 150, align: 'start' },
  { id: 'product_price', label: 'Product Price', minWidth: 100, align: 'start' },
  { id: 'description', label: 'Product Description', minWidth: 200, align: 'start' },
  { id: 'features', label: 'Product Features', minWidth: 200, align: 'start' },
  // { id: 'companyName', label: 'Company Name', minWidth: 150, align: 'start' },
  { id: 'status', label: 'Status', minWidth: 100, align: 'center' },
  { id: 'action', label: 'Action', minWidth: 150, align: 'center', actionType: [{ view: true, edit: true }] },
];

const ProductList = () => {
  const [searchQuery, setSearchQuery] = useState("");
   const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {Products} = useSelector((state) => state.product);
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(fetchProducts())
  },[])
  

  const handleSearch = () => {
  };

  const handleExport = () => {
  };

  const handleEdit = (val) => {
  };

  const handleView = (val) => {


  };
  const handleStatus=()=>{

  }

  return (
    <div className="content">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
          Product List <Typography component="span">({Products.length})</Typography>
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <TextField
            placeholder="Search by Product Name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            fullWidth
          />
          <Button variant="contained" onClick={handleSearch} color="success" sx={{
              
              "&:hover": { backgroundColor: "#2FB354" },}}>
            Search
          </Button>
          <Button
            variant="contained"
            startIcon={<DownloadIcon />}
            onClick={handleExport}
            color="success"
            sx={{ ml: 2, px: 3,
              "&:hover": { backgroundColor: "#2FB354" }, }}
          >
            Export
          </Button>
          <Link to="/datahub/product/add">
            <Button 
              variant="contained"
              startIcon={<Add />}
              color="success"
              sx={{ ml: 2, px: 2,
                "&:hover": { backgroundColor: "#2FB354" }, }}
                >
              Add
            </Button>
          </Link>
        </Box>
      </Box>

       <CustomTable
              columns={columns}
              rows={Products}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              handleEdit={handleEdit}
              handleView={handleView}
              handleStatus={handleStatus}
            />
    </div>
  );
};

export default ProductList;
